import React from 'react';
import { Helmet } from 'react-helmet';
import '../assets/styles/AIPoweredTradingLandingPage.css';
// Import images
import translateStocksLogo from '../assets/images/translatestocks-logo.png';
import tradingDashboard from '../assets/images/trading-dashboard.png';

const AIPoweredTradingLandingPage: React.FC = () => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted');
  };

  return (
    <div className="ai-trading-landing-page">
      <Helmet>
        <title>AI-Powered Trading Insights | TranslateStocks</title>
        <meta name="description" content="Predict market moves with AI-powered trading insights from TranslateStocks. Real-time market predictions to give you the edge." />
        <meta name="robots" content="noindex" /> {/* Make it unlisted */}
      </Helmet>

      <header className="landing-header">
        <div className="logo-container">
          <img src={translateStocksLogo} alt="TranslateStocks Logo" className="logo" />
        </div>
        <nav className="landing-nav">
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/features">Features</a></li>
            <li><a href="/analysis">Analysis</a></li>
          </ul>
        </nav>
      </header>

      <main>
        <section className="hero-section">
          <div className="hero-content">
            <div className="hero-text">
              <h1>
                Predict Market Moves With<br />
                <span className="ai-highlight">AI-Powered Trading</span><br />
                Insights
              </h1>
              <p className="hero-description">
                TranslateStocks combines cutting-edge Price on Rails technology with real-time 
                market predictions, giving you the edge to trade smarter and faster.
              </p>
              <div className="cta-button-container">
                <a href="#free-trial" className="cta-button">
                  <span className="icon">🔍</span> AI Insights Free Trial
                </a>
              </div>
            </div>

            <div className="signup-form-container">
              <div className="signup-form">
                <h2>Get Started with AI-Powered Trading Now!</h2>
                <form onSubmit={handleSubmit}>
                  <input type="text" placeholder="Full Name" required />
                  <input type="email" placeholder="Email Address" required />
                  <input type="tel" placeholder="Phone No" required />
                  <button type="submit" className="start-trial-button">Start Your Free Trial</button>
                </form>
              </div>
            </div>
          </div>
        </section>

        <section className="competitive-edge-section">
          <div className="competitive-edge-content">
            <div className="edge-image-container">
              <img src={tradingDashboard} alt="Trading Platform Dashboard" className="edge-image" />
            </div>
            <div className="edge-text">
              <h2>Your Competitive <span className="edge-highlight">Edge</span> In Trading</h2>
              <p>
                TranslateStocks is more than a platform—it's a next-generation trading powerhouse. Our Price 
                on Rails technology predicts potential price movements in real-time, while our AI-driven insights 
                empower you to act with confidence and precision.
              </p>
              <ul className="edge-features">
                <li><strong>Real-Time Predictions:</strong> See where the market's heading with Price on Rails.</li>
                <li><strong>AI-Powered Precision:</strong> Leverage advanced algorithms for smarter trades.</li>
                <li><strong>Speed & Control:</strong> Execute fast without losing intuitive command.</li>
              </ul>
              <div className="try-now-button-container">
                <a href="#try-it-free" className="try-now-button">
                  <span className="icon">💼</span> Try It Free Now
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AIPoweredTradingLandingPage; 